import { useEffect, useState } from "react";

/** true when viewport is wider than 900px */
export default function useIsDesktop(breakpoint = 900) {
  const [isDesktop, setIsDesktop] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    const media = window.matchMedia(`(min-width: ${breakpoint + 1}px)`);
    const onChange = () => setIsDesktop(media.matches);
    onChange();
    media.addEventListener("change", onChange);
    return () => media.removeEventListener("change", onChange);
  }, [breakpoint]);

  return { isDesktop, mounted };
}

/** 3 cards from 901-1100px, `wide` cards above 1100px. */
export function useDesktopSlides(wide = 4, mid = 3) {
  const { isDesktop, mounted } = useIsDesktop(900);
  const { isDesktop: isWide } = useIsDesktop(1100);
  return { isDesktop, mounted, slidesToShow: isWide ? wide : mid };
}
